import {
  AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { hasSentInvite } from "@/lib/calendar";

export const DeleteAppointmentDialog = ({ appt, onOpenChange, onDelete, onCancelAndDelete }) => {
  const sent = hasSentInvite(appt);
  return (
    <AlertDialog open={!!appt} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-2xl" data-testid="appt-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-[#0A1128]">Eliminare l'appuntamento?</AlertDialogTitle>
          <AlertDialogDescription>
            {sent
              ? `«${appt?.titolo}» è già stato inviato ai destinatari. Vuoi inviare loro l'annullamento così l'evento verrà rimosso dai loro calendari?`
              : `«${appt?.titolo}» verrà eliminato definitivamente.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel className="rounded-full" data-testid="appt-delete-cancel">Annulla</AlertDialogCancel>
          <Button variant="outline" onClick={() => onDelete(appt)} className={`rounded-full font-bold ${sent ? "" : "hidden"}`} data-testid="appt-delete-silent">Elimina senza avvisare</Button>
          <Button onClick={() => (sent ? onCancelAndDelete(appt) : onDelete(appt))} className="rounded-full bg-[#E8173A] hover:bg-[#C8102E] text-white font-bold" data-testid="appt-delete-confirm">
            {sent ? "Invia annullamento ed elimina" : "Elimina"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
